/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  addEtapa ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/etapa-licitacion/add', item, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          if (response.data.nuOk === 0) {
            item = response.data.id
            commit('ADD_ETAPA_CASO', item)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  setAllEtapasCaso ({ commit }, item) {
    return new Promise((resolve, reject) => {
      commit('SET_ETAPA_CASO', item)
      resolve(item)
    })
  },
  getAllEtapasCaso ({ commit }) {
    return new Promise((resolve, reject) => {

      axios.get('/api/etapa-licitacion', {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          commit('SET_ETAPA_CASO', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getEtapasCasoByCaso ({ commit }, item) {
    return new Promise((resolve, reject) => {

      axios.get(`/api/etapa-licitacion/${item.IDLICITACION}`, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          commit('SET_ETAPA_CASO', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAllEtapasByCaso ({ commit }, item) {
    //console.log('getAllEtapasByCaso request', item)
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/getAllEtapasByCaso',
          { idRequest: item },
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('getAllEtapasByCaso response,', response.data)

          if (response.data.nuOk === 0) {
            const lista = response.data.listStagesByRequest ? response.data.listStagesByRequest : []
            commit('SET_ETAPA_CASO', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          //console.log('Error', error.toString())
          reject(error)
        })
    })
  },
  updateEtapa ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/api/etapa-licitacion/update', item, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          if (response.data.nuOk === 0) {
            commit('UPDATE_ETAPA_CASO', item)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  removeEtapaCaso ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.post('/api/etapa-licitacion/delete', {id: itemId}, {
        headers: {Authorization: `Bearer ${  localStorage.getItem('accessToken')}`}
      })
        .then((response) => {
          if (response.data.nuOk === 0) {
            commit('REMOVE_ETAPA_CASO', itemId)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  createIdNugruPhase ({ commit }, item ) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/preProcessCaseByUser',
          {
            idUser: item.idUser,
            agrupa: item.agrupa
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          // Se compara con 1 porque el servicio REST responde asi, si se cambia a 0 posiblemente se dañen mas cosas
          if (response.data.nuOK === 1) {
            const codigoGrupo = response.data.idNugruPhaseStg ? response.data.idNugruPhaseStg : null;
            commit('SET_CODIGO_GRUPO', codigoGrupo)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  processRequestByMultiPhase ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/processRequestByMultiPhase',
          {
            idUser: item.idUser,
            idRequest: item.idRequest,
            idRequestPhaseStg: item.idRequestPhaseStg,
            idNugruPhaseStg: item.idNugruPhaseStg
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('processRequestByMultiPhase response', JSON.stringify(response.data))
          if (response.data.nuOK === 0) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
